import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';
import ArticleCreateContent from '../../../components/Pages/Articles/Create';

export default function ArticleCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Article Create page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <ArticleCreateContent />
    </Layout>
  );
}
